import { MeshSpectrum, SoundWaveType } from '@beatflyer/shaders-lib';
import { loadImage } from '../utils';
import { FrameData, SoundWaveFrameData } from './FlyerData';
import { Frame } from './Frame';
import { FrameType } from './FrameType';

export class SoundWaveFrame extends Frame {
  type = FrameType.SoundWave;
  isEditable = true;
  isResizable = true;

  waveType: SoundWaveType;
  thumbnailImage: HTMLImageElement;

  get canRotate(): boolean {
    return true;
  }

  get meshSpectrum(): MeshSpectrum {
    return this.sprite as MeshSpectrum;
  }

  get boundingBox(): PIXI.Rectangle {
    return this._boundingBox;
  }
  set boundingBox(value: PIXI.Rectangle) {
    this._boundingBox = value;
    if (this.sprite) {
      this.sprite.x = value.x + value.width / 2;
      this.sprite.y = value.y + value.height / 2;
      this.sprite.width = value.width;
      this.sprite.height = value.height;
    }
  }

  get color(): string {
    return this.meshSpectrum.getProperty('color');
  }

  set color(hex: string) {
    this.meshSpectrum.setProperty('color', hex);
    this.emit('update');
  }

  async load() {
    if (this.isLoaded) {
      return;
    }
    const url = `/media/sound-waves-thumbs/sound-wave-${this.waveType}.png`;
    this.thumbnailImage = await loadImage(url);
    // colorize based on color
    this.generateThumbnail();
    this.isLoaded = true;
    this.emit('load');
  }

  generateThumbnail(): void {
    if (this.thumbnailURL) {
      URL.revokeObjectURL(this.thumbnailURL);
    }
    const THUMBNAIL_SIZE: number = 120;
    const canvas = document.createElement('canvas');
    canvas.width = THUMBNAIL_SIZE;
    canvas.height = THUMBNAIL_SIZE;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(this.thumbnailImage, 0, 0, THUMBNAIL_SIZE, THUMBNAIL_SIZE);
      ctx.globalCompositeOperation = 'source-in';
      ctx.fillStyle = this.sprite.getProperty('color');
      ctx.fillRect(0, 0, THUMBNAIL_SIZE, THUMBNAIL_SIZE);
    }
    this.thumbnailURL = canvas.toDataURL('image/png');
  }

  populateWithData(data: FrameData) {
    const soundWaveData = data as SoundWaveFrameData;
    this.waveType = soundWaveData.waveType;
    const meshId = 'mesh-sound-wave-' + this.waveType;
    const clazz = (window as any).BeatFlyer.filters[meshId];
    if (!clazz) {
      throw new Error(`Cannot find mesh ${meshId}`);
    }
    this.sprite = new clazz(soundWaveData.effectProperties);
    const { x, y, width, height } = soundWaveData.box;
    this.boundingBox = new PIXI.Rectangle(x, y, width, height);
    if (soundWaveData.rotation) {
      this.rotation = soundWaveData.rotation;
    }
  }

  asData(forDatabase: boolean): FrameData {
    const { x, y, width, height } = this.boundingBox;
    const result: SoundWaveFrameData = {
      ...super.asData(forDatabase),
      waveType: this.waveType,
      box: {
        x,
        y,
        width,
        height
      },
      effectProperties: this.sprite.toObject()
    };
    return result;
  }

  clone(): Frame {
    const clone = new SoundWaveFrame(this.stageWidth, this.stageHeight);
    clone.populateWithData(this.asData(false));
    clone.backgroundStyle = this.backgroundStyle;
    return clone;
  }
}



// WEBPACK FOOTER //
// ./src/data/SoundWaveFrame.ts